import React from 'react';
import {NavLink} from 'react-router-dom';
import Badge from '../Badges/Badge';
import { ColourMod } from '../../Data/Enums/LayoutEnums';
import {RouteInterface} from "../../Types/RouteType";

export interface iGroupedNavigationEntry {
	groupTitle: string;
	items: Array<iNavigationEntry>;
}

export interface iNavigationEntry extends RouteInterface {
	badgeCount?: string | number;
	callback?: (e: any) => void;
	disabled?: boolean;
	active?: boolean;
}

const SectionNavigationEntry: React.FC<iNavigationEntry> = (entry) => {
	return (
		<NavLink
			className={`section-navigation-entry ${entry.disabled ? 'disabled' : ''}`}
			to={entry.path}
			title={entry.title}
		>
			{!!entry.icon && entry.icon}

			<div className='section-navigation-entry-title'>{entry.title}</div>

			{!!entry.badgeCount && (
				<Badge count={entry.badgeCount as number} description={'true'} colour={ColourMod.Alert}  />
			)}
		</NavLink>
	);
};

export default SectionNavigationEntry;
